import { comparisonBooleanDisplay } from './comparison-boolean-display';

// One display rule for both comparison tables, specifications and copied specifications.
export function formatProductAttributeValue(value: unknown, unit: string | undefined, language: string): string {
  if (value === null || value === undefined) return '-';
  if (typeof value === 'object') {
    if ('value' in (value as Record<string, unknown>)) {
      const v = (value as { value: unknown; unit?: string });
      const booleanDisplay = comparisonBooleanDisplay(v.value, language);
      if (booleanDisplay !== undefined) return booleanDisplay;
      const valStr = String(v.value);
      // Don't append unit if value already contains it (e.g., "635g" with unit "g" -> "635g", not "635g g")
      if (v.unit && valStr.toLowerCase().endsWith(v.unit.toLowerCase())) {
        return valStr;
      }
      return `${v.value}${v.unit ? ` ${v.unit}` : ''}`;
    }
    return JSON.stringify(value);
  }
  const booleanDisplay = comparisonBooleanDisplay(value, language);
  if (booleanDisplay !== undefined) return booleanDisplay;
  // Don't append unit if value already contains it (e.g., "635g" with unit "g" -> "635g", not "635g g")
  const valStr = String(value);
  if (unit && valStr.toLowerCase().endsWith(unit.toLowerCase())) {
    return valStr;
  }
  return `${value}${unit ? ` ${unit}` : ''}`;
}

